<template>
  <b-row>
    <h1>알림톡 등록 신청</h1>
    <b-breadcrumb>
      <b-breadcrumb-item>{{currentUser.userRole == "BRAND_ADMIN"?'사이트 관리':'매장 관리'}}</b-breadcrumb-item>
      <b-breadcrumb-item>알림톡 등록 신청</b-breadcrumb-item>
    </b-breadcrumb>
    <modal_image ref="modal_image1" :data="smsRegisterDocumentUrl" />
    <modal_image ref="modal_image2" :data="smsCertificateDocumentUrl" />
    <b-colxx xxs="12">
      <b-card class="mb-4" :title="`${storeName!=null&&storeName!=undefined&&storeName!=''? '매장' : '사이트'} 알림톡 등록 신청`">
        <b-form-group label-cols="2" horizontal class="weight600" id="kakaoIdLabel">
          <template v-slot:label>
            카카오톡 채널 ID
            <i class="simple-icon-info mt-1 d-inline" id="kakaoModalTarget" ></i>
            <b-tooltip target="kakaoModalTarget" placement="top" data-placement="top" custom-class="justifytooltip" >
              <div class="text-left">
                <li>”카카오채널 관리자센터” 접속</li>
                <li>좌측 상단 ”채널” 메뉴로 이동</li>
                <li>검색용 아이디 확인 가능 (ex. @테이블엔조이)</li>
              </div>
            </b-tooltip>
          </template>
<!--          <b-tooltip target="kakaoModalTarget"  placement="top">-->
<!--            test <br>-->
<!--            test <br>-->
<!--            test <br>-->
<!--            &lt;!&ndash;              <img src='/assets/img/kakaoChannelIdGuide.jpeg' /> &ndash;&gt;-->
<!--          </b-tooltip>-->


          <b-form-input placeholder="검색용 아이디 (ex @예약안내)" maxlength="40" class="col-6 d-inline" v-model="kakaoId"></b-form-input>

        </b-form-group>
        <b-form-group label-cols="2" horizontal label="관리자 휴대폰번호" class="weight600">
          <div class="input-group">
            <b-form-input placeholder="카카오톡 채널에 등록된 휴대폰번호" maxlength="40" class="col-4" v-model="adminNumber"></b-form-input>
            <button class="btn btn-outline-primary default ml-1 col-2" @click="otpRequest">인증번호 발송</button>
          </div>
        </b-form-group>
        <b-form-group label-cols="2" horizontal label="인증번호" class="weight600">
          <b-form-input placeholder="" maxlength="40" class="col-4" v-model="token"></b-form-input>
        </b-form-group>
        <b-form-group label-cols="2" horizontal label="카테고리" class="weight600">
          <b-form-select class="mt-2 col-2" v-model="alimtalkLargeForm" @change="getAlimtalkMiddleForm(alimtalkLargeForm)">
            <b-form-select-option v-for="item in alimtalkLargeFormList" :key="item.mainCategoryCode"
                                  :value="item.mainCategoryCode"
            >{{item.mainCategory}}
            </b-form-select-option>
          </b-form-select>
          <b-form-select class="mt-2 col-2" v-model="alimtalkMiddleForm" @change="getAlimtalkSmallForm(alimtalkMiddleForm)">
            <b-form-select-option v-for="item in alimtalkMiddleFormList" :key="item.middleCategoryCode"
                                  :value="item.middleCategoryCode"
            >{{item.middleCategory}}
            </b-form-select-option>
          </b-form-select>
          <b-form-select class="mt-2 col-2" v-model="alimtalkSmallForm" >
            <b-form-select-option v-for="item in alimtalkSmallFormList" :key="item.smallCategoryCode"
                                  :value="item.smallCategoryCode"
            >{{item.smallCategory}}
            </b-form-select-option>
          </b-form-select>
        </b-form-group>
        <b-form-group label-cols="2" horizontal label="발신번호 등록 신청" class="weight600">
          <div class="input-group">
            <b-form-checkbox v-model="smsRegister" @change="chkSmsRegister(!smsRegister)" class="mt-2 mr-3">신청</b-form-checkbox>
            <a class="btn btn-outline-success default text-success" style="cursor: pointer" href="https://hitable2020images.blob.core.windows.net/etc/tablenjoy/2023-08/U.STRATalk_발신번호사전등록신청서_v1.0 (3).docx" download="">등록 신청서 다운로드</a>
          </div>
        </b-form-group>
        <b-row>
          <div class="col-2"></div>
          <div class="col-8">
            <label>
              * 고객의 카카오톡 설치 유무, 네트워크 환경에 따라서 발신 실패 시 문자(SMS)로 대체 발송 처리됩니다. <br>
              * 문자(SMS) 발송 시 수신자에게 표시되는 전화번호 변경을 원하시는 경우 발신번호 등록이 필요합니다. <br>
              * 신청하지 않을 경우 테이블엔조이 고객센터(1600-3662) 번호로 발신됩니다.<br>
              * 알림톡 등록 이후 발신번호 별도 신청 불가합니다.
            </label>
          </div>
        </b-row>
        <template v-if="smsRegister">
          <b-row>
            <div class="col-2"></div>
            <div class="col-8">
              <b-form-group label-cols="2" horizontal label="발신번호" class="weight600 " >
                <b-form-input class="col-11 mr-auto" placeholder="문자 발송에 사용할 발신번호" v-model="smsSendNumber" ></b-form-input>
              </b-form-group>
              <b-form-group label-cols="2" horizontal label="등록신청서" class="weight600">
                <b-input-group class="pl-0 fileInputSize">
                  <b-form-file accept="image/*" placeholder="파일 선택" :browse-text="browseText1" v-model="smsRegisterDocumentUrl"></b-form-file>
                  <b-input-group-append v-if=" smsRegisterDocumentUrl">
                    <b-button class="fileCustomBtn" variant="outline-secondary" @click="getBusinessLicenseImage1" >미리보기</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
              <b-form-group label-cols="2" horizontal label="통신사이용증명원" class="weight600">
                <b-input-group class="pl-0 fileInputSize">
                  <b-form-file accept="image/*" placeholder="파일 선택" :browse-text="browseText2" v-model="smsCertificateDocumentUrl" ></b-form-file>
                  <b-input-group-append v-if=" smsCertificateDocumentUrl">
                    <b-button class="fileCustomBtn" variant="outline-secondary" @click="getBusinessLicenseImage2" >미리보기</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </div>
          </b-row>
        </template>
        <b-row class="justify-content-center">
          <button @click="back" class="btn btn-outline-danger mr-4">취소</button>
          <button @click="regAlimtalk" class="btn btn-success">등록 신청</button>
        </b-row>
      </b-card>
    </b-colxx>
  </b-row>
</template>


<script>

import api from "@/constants/api";
import {mapGetters} from "vuex";
import StoreFileUploader from "@/components/Upload/StoreFileUploader.vue";
import modal_image from "@/views/shop/components/ModalImage.vue";
import {ContainerClient} from "@azure/storage-blob";

export default {
  components: {modal_image, 'store-file-uploader': StoreFileUploader,},
  data() {
    return{
      phoneData: false,
      kakaoId: "",
      sendKey: "",
      status: "",
      smsSendNumber: "",
      smsRegisterDocumentUrl: "",
      smsRegisterDocumentUrl_bak:'파일 선택',
      smsCertificateDocumentUrl: "",
      smsCertificateDocumentUrl_bak: '파일 선택',
      smsRegister:false,
      adminNumber:"",
      token:"",
      tmpData:{},
      storeCode:"",
      browseText1:"등록",
      browseText2:"등록",
      storeName : "",
      regCode: "NEW",
      tooltipOption : {
        title:"<img src='/assets/img/kakaoChannelIdGuide.jpeg' />",
        placement:"right",
      },
      alimtalkLargeForm:"",
      alimtalkLargeFormList:[],
      alimtalkMiddleForm:"",
      alimtalkMiddleFormList:[],
      alimtalkSmallForm:"",
      alimtalkSmallFormList:[],
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'siteName','info'])

  },
  watch:{
    'smsRegisterDocumentUrl'(value) {
      console.log(value);
      this.browseText1 = this.smsRegisterDocumentUrl == null ? '등록' : "수정"

      if (value.type != undefined) {
        const azureInfo = this.AzureFileUpload1();
        console.log(azureInfo)
      }
    },
    'smsCertificateDocumentUrl'(value) {
      console.log(value);
      this.browseText2 = this.smsCertificateDocumentUrl == null ? '등록' : "수정"

      if (value.type != undefined) {
        const azureInfo = this.AzureFileUpload2();
        console.log(azureInfo)
      }
    }

  },
  created() {
    if(this.currentUser.userRole != "BRAND_ADMIN"){
      if(this.$route.query.storeCode !=null && this.$route.query.storeCode !=undefined && this.$route.query.storeCode != '' ){
        this.storeCode = this.$route.query.storeCode
        this.chkStore();
      }else{
        this.storeCode = this.info.storeCode
        this.chkStore();
      }
    }else{
      this.storeCode = this.$route.query.storeCode
      this.chkStore();
    }
    if(this.$route.query.reg !=null && this.$route.query.reg !=undefined && this.$route.query.reg != '' ){
      this.regCode = this.$route.query.reg
    }
    console.log(this.regCode)
    this.getAlimtalkLargeForm();

  },
  beforeMount() {

  },
  mounted() {
    //let popupItem = document.getElementsByClassName("bv-no-focus-ring col")[0];
    // let popupItem = document.getElementById("kakaoIdLabel__BV_label_");
    // console.log(popupItem)
    // let tooltipItem = '<i class="simple-icon-info ml-2 mt-1" id="kakaoModalTarget" > </i>';
    // // let tooltipItem2 = '<b-tooltip target="kakaoModalTarget" placement="bottom" title="item.body"> </b-tooltip>'
    // popupItem.insertAdjacentHTML('beforeend',tooltipItem);
    // // popupItem.insertAdjacentHTML('beforeend',tooltipItem2);
    // let kakaoModalTarget = document.getElementById('kakaoModalTarget')
    //
    // kakaoModalTarget.addEventListener("mouseover",()=>{
    //   let kakaoTooltip = '<span id="kakaoTooltip" class="tooltiptext "><img class="fixZindex" id="kakaoTooltipimg" src="/assets/img/kakaoChannelIdGuide.jpeg" /></span>'
    //   kakaoModalTarget.insertAdjacentHTML('beforeend',kakaoTooltip);
    //   console.log('aa')
    // })
    // kakaoModalTarget.addEventListener("mouseleave",()=>{
    //   let deleteItem = document.getElementById('kakaoTooltip')
    //   let deleteImgItem = document.getElementById('kakaoTooltipimg')
    //   deleteItem.remove()
    //   deleteImgItem.remove()
    // })

  },
  methods:{
    chkStore(){
      let reqURL = ''
      reqURL = api.changeAPI(this.siteName, api.basicURL + api.alimtalkMng.getStoreInfo+`?storeCode=${this.storeCode}`)
      let params = {"storeCode": this.storeCode}
      this.$http.get(reqURL,params,  {
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res => {
        // ;
        if (res.data.code === "OK") {
          this.storeName = res.data.data.basicInfo.storeName

        } else {
          throw 400
        }
      }).catch(err => {
        //alert(err.response.data.message);

      })


    },
    back(){
      this.$router.go(-1)
    },
    regAlimtalk(){

      let reqURL = ''
      let params ={}
      let alertWord = ''
      let alertWordAdd=''
      if(!this.kakaoId){
        alertWord += '카카오톡 채널 ID를 입력해 주세요.\n'
      }
      if(this.kakaoId!=null && this.kakaoId!=undefined && this.kakaoId!='' && !this.kakaoId.startsWith('@',0) ){
        alertWord += '카카오톡 채널 ID 형식이 올바르지 않습니다. 첫 문자는 @로 시작되어야 합니다. \n'
      }
      if(!this.adminNumber){
        alertWord += '휴대폰번호를 입력해 주세요. \n'
      }
      if(!this.token){
        alertWord += '인증번호를 입력해 주세요. \n'
      }
      if(!this.alimtalkSmallForm){
        alertWord += '카테고리를 입력해 주세요. \n'
      }
      let smsSendToggle = true
      let smsDocToggle = true
      let smsCertToggle = true
      if(this.smsRegister){
        if(!this.smsSendNumber){
          alertWordAdd += '발신 번호를 입력해 주세요. \n'
          smsSendToggle = false
        }
        if(!this.smsRegisterDocumentUrl){
          alertWordAdd += '등록신청서를 입력해 주세요. \n'
          smsDocToggle = false
        }
        if(!this.smsCertificateDocumentUrl){
          alertWordAdd += '통신사이용증명원을 입력해 주세요. \n'
          smsCertToggle = false
        }
      }

      if(!this.kakaoId || !this.kakaoId.startsWith('@',0) || !this.adminNumber || !this.adminNumber || !this.token ||!this.alimtalkSmallForm) {
        if (this.smsRegister) {
          alert(alertWord + alertWordAdd);
        } else {
          alert(alertWord);
        }
        return false;
      }else if(this.smsRegister&& (!smsSendToggle || !smsDocToggle || !smsCertToggle) ){
        alert(alertWord + alertWordAdd);
        return false;
      }else{

          if( !this.storeCode ) {
            reqURL = api.changeAPI(this.siteName, api.basicURL + api.alimtalkMng.regBrandAlimtalk)
            params = {
              type : "SITE",
              kakaoId : this.kakaoId,
              token: this.token,
              phoneNumber: this.adminNumber,
              smsRegister : this.smsRegister,
              smsSendNumber : this.smsSendNumber,
              smsRegisterDocumentUrl : this.smsRegisterDocumentUrl,
              smsCertificateDocumentUrl : this.smsCertificateDocumentUrl,
              categoryCode : this.alimtalkSmallForm,
              registerType: this.regCode,

            }
          }else{
            reqURL = api.changeAPI(this.siteName, api.basicURL + api.alimtalkMng.regBrandStoreAlimtalk)
            params = {
              type : "STORE",
              kakaoId : this.kakaoId,
              token: this.token,
              phoneNumber: this.adminNumber,
              smsRegister : this.smsRegister,
              smsSendNumber : this.smsSendNumber,
              smsRegisterDocumentUrl : this.smsRegisterDocumentUrl,
              smsCertificateDocumentUrl : this.smsCertificateDocumentUrl,
              categoryCode : this.alimtalkSmallForm,
              storeCode : this.storeCode,
              registerType: this.regCode
            }
          }

        this.$http.post(reqURL,params,  {
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }).then(res => {
          // ;
          if (res.data.code === "OK") {
            this.tmpData = res.data.data
            this.$router.push(`${'/'+this.siteName+'/siteSet/AlimtalkMng'}`)
          } else {
            throw 400
          }
        }).catch(err => {
          alert(err.response.data.message);

        })

      }


    },
    otpRequest(){
      let reqURL = ''
      reqURL = api.changeAPI(this.siteName, api.basicURL + api.alimtalkMng.requestOtp)
      const params = {
        kakaoId: this.kakaoId,
        phoneNumber: this.adminNumber
      }
      //otp 유효성검사
      let alertWord = ''
      if(!this.kakaoId){
        alertWord += '카카오톡 채널 ID를 입력해 주세요.\n'
      }
      if(this.kakaoId!=null && this.kakaoId!=undefined && this.kakaoId!='' && !this.kakaoId.startsWith('@',0)){
        alertWord += '카카오톡 채널 ID 형식이 올바르지 않습니다. 첫 문자는 @로 시작되어야 합니다. \n'
      }
      if(!this.adminNumber){
        alertWord += '관리자 휴대폰번호를 입력해 주세요. \n'
      }

      if(!this.kakaoId || !this.kakaoId.startsWith('@',0) || !this.adminNumber){
        alert(alertWord);
        return false;
      }else{
        this.$http.post(reqURL,params,  {
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }).then(res => {
          // ;
          if (res.data.code === "OK") {
            this.tmpData = res.data.data
            alert("요청이 성공하였습니다.")
          } else {
            throw 400
          }
        }).catch(err => {
          alert(err.response.data.message);
        })
      }

    },
    AzureFileUpload1() {
      const vm = this;
      return new Promise(function (resolve, reject) {
        let reqURL = api.changeAPI(vm.siteName, api.basicURL + api.user.azureSas);
        let params = {
          type: "ETC"
        }

        vm.$http.post(reqURL, params, {
          headers: {
            'Authorization': `Bearer ${vm.currentUser.tokens.access.token}`
          }
        }).then(res => {

          if (res.data.code === "OK") {
            let containerUrl = res.data.data.url
            const containerClient = new ContainerClient(containerUrl);

            const file = vm.smsRegisterDocumentUrl;
            console.log(file)
            const blockBlobClient = containerClient.getBlockBlobClient(`${res.data.data.directory}/${file.name}`);

            blockBlobClient.uploadBrowserData(file, {
              blockSize: 4 * 1024 * 1024, // 4MB block size
              blobHTTPHeaders: {
                blobContentType: file.type
              }
            }).then(success => {
              console.log("success", success)
              let uploadedUrl = success._response.request.url.substring(0, success._response.request.url.indexOf("?sig="))
              vm.smsRegisterDocumentUrl = uploadedUrl
              console.log(vm.smsRegisterDocumentUrl);


            }).catch(reason => {
              alert("업로드 실패")

            })
            resolve('sss');
          } else {
            throw 400
          }
        }).catch(err => {
          reject(new Error('업로드 실패'));
        });
      })

    },
    AzureFileUpload2() {
      const vm = this;
      return new Promise(function (resolve, reject) {
        let reqURL = api.changeAPI(vm.siteName, api.basicURL + api.user.azureSas);
        let params = {
          type: "ETC"
        }
        vm.$http.post(reqURL, params, {
          headers: {
            'Authorization': `Bearer ${vm.currentUser.tokens.access.token}`
          }
        }).then(res => {
          if (res.data.code === "OK") {
            let containerUrl = res.data.data.url
            const containerClient = new ContainerClient(containerUrl);

            const file = vm.smsCertificateDocumentUrl;

            const blockBlobClient = containerClient.getBlockBlobClient(`${res.data.data.directory}/${file.name}`);

            blockBlobClient.uploadBrowserData(file, {
              blockSize: 4 * 1024 * 1024, // 4MB block size
              blobHTTPHeaders: {
                blobContentType: file.type
              }
            }).then(success => {
              console.log("success", success)
              let uploadedUrl = success._response.request.url.substring(0, success._response.request.url.indexOf("?sig="))
              vm.smsCertificateDocumentUrl = uploadedUrl
              console.log(vm.smsCertificateDocumentUrl);

            }).catch(reason => {
              alert("업로드 실패")
            })
            resolve('sss');
          } else {
            throw 400
          }
        }).catch(err => {
          console.log(err)
          reject(new Error('업로드 실패'));

        });
      })

    },
    getAlimtalkLargeForm(){
      let reqURL = ''
      reqURL = api.changeAPI(this.siteName, api.basicURL + api.alimtalkMng.alimtalkLargeForm)
      this.$http.get(reqURL,  {
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res => {
        // ;
        console.log(res)
        if (res.data.code === "OK") {
          this.alimtalkLargeFormList = res.data.data.mainCategoryList
          this.alimtalkLargeFormList.unshift({mainCategoryCode:'',mainCategory:'대분류선택'})
        } else {
          throw 400
        }
      }).catch(err => {
        //alert(err.response.data.message);
      })
    },
    getAlimtalkMiddleForm(item){
      this.alimtalkMiddleFormList=[]
      this.alimtalkMiddleForm=""
      this.alimtalkSmallFormList=[]
      this.alimtalkSmallForm=""
      let reqURL = ''
      reqURL = api.changeAPI(this.siteName, api.basicURL + api.alimtalkMng.alimtalkMiddleForm+ "?mainCategoryCode=" + item)
      this.$http.get(reqURL,  {
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res => {
        // ;

        if (res.data.code === "OK") {
          this.alimtalkMiddleFormList = res.data.data.middleCategoryList
          this.alimtalkMiddleFormList.unshift({middleCategoryCode:'',middleCategory:'중분류선택'})
        } else {
          throw 400
        }
      }).catch(err => {
        //alert(err.response.data.message);
      })
    },
    getAlimtalkSmallForm(item){
      this.alimtalkSmallFormList=[]
      this.alimtalkSmallForm=""
      let reqURL = ''
      reqURL = api.changeAPI(this.siteName, api.basicURL + api.alimtalkMng.alimtalkSmallForm+ "?middleCategoryCode=" + item)
      this.$http.get(reqURL,  {
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res => {
        // ;
        console.log(res)
        if (res.data.code === "OK") {
          this.alimtalkSmallFormList = res.data.data.smallCategoryList
          this.alimtalkSmallFormList.unshift({smallCategoryCode:'',smallCategory:'소분류선택'})
        } else {
          throw 400
        }
      }).catch(err => {
        //alert(err.response.data.message);
      })
    },
    chkSmsRegister(value){
      if(!value){
        this.smsRegisterDocumentUrl=""
        this.smsCertificateDocumentUrl=""
        this.smsSendNumber=""

      }
    },
    getBusinessLicenseImage1: function () {

      let tmp = this.smsRegisterDocumentUrl.substr(this.smsRegisterDocumentUrl.length-3,3)
      if(tmp == 'pdf'){
        this.windowRef = window.open(this.smsRegisterDocumentUrl, "", "width=600,height=400,left=200,top=200");
      }else{
        this.popupImage1()
      }

    },
    getBusinessLicenseImage2: function () {
      let tmp = this.smsCertificateDocumentUrl.substr(this.smsCertificateDocumentUrl.length-3,3)
      if(tmp == 'pdf'){
        this.windowRef = window.open(this.smsCertificateDocumentUrl, "", "width=600,height=400,left=200,top=200");
      }else{
        this.popupImage2()
      }

    },
    popupImage1() {
      this.$refs.modal_image1.open()
    },
    popupImage2() {
      this.$refs.modal_image2.open()
    },
  }
}
</script>

<style>

.justifytooltip { transform: translate3d(392px, 46px, 0px) !important; }

</style>
